import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Circle } from "lucide-react";
import { LoTagListStyle } from "./CarouselCard.style";

type ITopicTags = {
  topicTags: string[] | undefined;
  tagsCollapsed?: boolean,
}

export const TopicTags = ({
  topicTags = [],
  tagsCollapsed = false
}: ITopicTags) => {

  const theme = useTheme();

  function takeFirstTwo(): { topicTags: string[]; omitted: number } {
    const firstTwo = topicTags.slice(0, 2);
    const omitted = Math.max(0, topicTags.length - firstTwo.length);
    return { topicTags: firstTwo, omitted };
  }

  let topicTagsObject = takeFirstTwo();

  const omittedTags = () => topicTagsObject.omitted > 0;

  return (
    <LoTagListStyle 
      className={ "lo_tag_list" + tagsCollapsed && " hidden" }
    >
      { topicTagsObject.topicTags.length > 0 && topicTagsObject.topicTags?.map((tag: string, i: number) => {
        return (
          <Box
            key={ i }
            sx={ {
              display: "flex",
              justifyContent: "left",
              alignItems: "center"
            } }>
            <Circle style={ { marginLeft: i !== 0 ? "8px" : "0", marginRight: "3px" } }
              fill={ theme.customColors.accentVariantA } size={ "0.4375rem" } />
            <Typography
              sx={ {
                color: theme.customColors.exploreCardText,
                fontSize: "0.75rem",
                marginLeft: "0.3rem"
              } }
              variant="body2"
            >
              { tag.charAt(0).toUpperCase() + tag.slice(1) }
            </Typography>
          </Box>
        );

      }) }
      { omittedTags() && (
        <Typography
          sx={ {
            color: theme.customColors.exploreCardText,
            fontSize: "0.75rem",
            marginLeft: "0.44rem"
          } }
          variant="body2"
        >
          { " " } + { topicTagsObject.omitted }
        </Typography>

      ) }
    </LoTagListStyle>
  );
};
